module.exports = __webpack_public_path__ + "img/madeira.38718f96.svg";